import Swal from "sweetalert2"

export const SuccessSwal = (title, text, reload) => {
    Swal.fire({
        title: title,
        text: text,
        icon: 'success',
        confirmButtonText: 'Ok',
    }).then(() => {
        if (reload) {
            window.location.reload();
        }
    });
}

export const ErrorSwal = (title, text, reload) => {
    Swal.fire({
        title: title,
        text: text,
        icon: 'error',
        confirmButtonText: 'Ok'
    })
        .then(() => {
            if (reload) {
                window.location.reload();
            }
        });
}